import { render } from "./ToolsView.vue?vue&type=template&id=4fc4e1be&scoped=true&ts=true"
import script from "./ToolsView.vue?vue&type=script&lang=ts"
export * from "./ToolsView.vue?vue&type=script&lang=ts"

import "./ToolsView.vue?vue&type=style&index=0&id=4fc4e1be&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc4e1be"]])

export default __exports__